import { forwardRef, InputHTMLAttributes } from "react";

import { cn } from "@/utils";

type InputSize = "s" | "m";
interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  size?: InputSize;
}

const SIZES: Record<InputSize, string> = {
  s: "h-10 rounded-lg px-3 py-[10px]",
  m: "h-[46px] rounded-[10px] px-4 py-3",
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", size = "m", ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn([
          "p2-medium flex w-full",
          "bg-surface-secondary text-item-primary ring-offset-surface-secondary transition-colors duration-100",
          "file:border-0 file:bg-transparent file:text-sm",
          "file:font-medium placeholder:text-item-secondary",
          // Hover
          "hover:bg-surface-tertiary",
          // Focus
          "focus:outline focus:outline-1 focus:outline-border-active",
          // Disabled
          "disabled:cursor-not-allowed disabled:text-item-tertiary disabled:placeholder:text-item-tertiary disabled:hover:bg-surface-secondary",
          SIZES[size],
          className,
        ])}
        {...(props.type === "text" && {
          "data-lpignore": "true",
          "data-1p-ignore": true,
          "data-bwignore": true,
        })}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";
